import { createAction } from 'redux-actions';
import { AppState } from '../types/store';

export type EmailUnsubscribeParams = AppState['emailUnsubscribe'];

export const unsubscribe = createAction(
  'EMAIL_UNSUBSCRIBE.UNSUBSCRIBE',
  (params: EmailUnsubscribeParams) => params
);

export const unsubscribeSuccess = createAction(
  'EMAIL_UNSUBSCRIBE.UNSUBSCRIBE_SUCCESS',
  () => ({})
);
